module.exports = __webpack_public_path__ + "img/Download.7ee92808.svg";